import { defineMessages } from 'react-intl';

export default defineMessages({
  returnItems: {
    id: 'tzTr0M',
    defaultMessage: 'Return Items',
    description: 'Title for the return items section',
  },
  sectionAriaLabel: {
    defaultMessage: 'Return Items expander section',
    description: 'Aria label for the expandable return items section',
    id: 'zYGo2D',
  },
});
